<template>
    <div class="category-promo my-2">
        <v-row>
             <v-col class="text-center">            
                <div class="font-weight-bold headline text-uppercase">{{ currentCategory.name }}</div>                                            
                <div class="description" v-if="currentCategory.description" v-html="currentCategory.description" ></div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" :md="allProducts.length > 1 ? 6 : 12" :lg="allProducts.length > 1 ? 6 : 12" sm="12" v-for="product in allProducts" :key="product.id">
                <v-img
                        :src="product.imageUrl"
                        contain
                        max-height="287"
                        max-width="573"
                        class="mx-auto"
                >
                    <div class="image-caption d-flex justify-end align-end">
                        <v-btn fab v-if="product.isGiftCard" :to="'/gift-product/' + product.alias">
                            <v-icon color="primary">mdi-gift</v-icon>
                        </v-btn>
                        <img class="ml-3" :src="require('../../assets/button.png')" @click="addToCart({product: product, qty: 1})" />
                    </div>
                </v-img>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'Promo',
        data () {
            return {

            }
        },
        computed: {
            ...mapGetters([
                'allProducts',
                'currentCategory'
            ]),
            imageUrl() {
                return process.env.VUE_APP_ROOT_API;
            }
        },
        methods: {
            ...mapActions([
                'addToCart'
            ])
        }
    }
</script>

<style lang="scss">
    .category-promo {
        .image-caption {
            bottom: 0;
            position: absolute;
            padding: 9px;
            right: 0;
            cursor: pointer;
        }
    }
</style>
